import { useEffect } from 'react';
import { useRouter } from 'next/compat/router';
import getUserArticlePoaTimePoints from '../query/getUserArticlePoaTimePoints';
import { useT2Query } from '../../../hooks/useT2Query';

type TUseGetUserArticlePoaTimePoints = {
  articleId: string;
  pollInterval?: number;
  skip?: boolean;
};
const INITIAL_USER_ARTICLE_TIME_POINTS = 0;

export const useGetUserArticlePoaTimePoints = ({ articleId, pollInterval, skip }: TUseGetUserArticlePoaTimePoints) => {
  const router = useRouter();
  const {
    data,
    loading: isUserArticleTimePointsLoading,
    error,
  } = useT2Query(getUserArticlePoaTimePoints, {
    variables: { articleId },
    pollInterval,
    skip,
  });

  useEffect(() => {
    if (error?.message === 'Unauthenticated') {
      // Due to:
      // 1) bug in privy, related to `privy-token` cookie being expired
      // but app still thinks user is logged in (due to cookie existing in LocalStorage and PrivyProvider memory);
      // 2) `PrivyInterface.getAccessToken()` is not refreshing cookies;
      // we need to reload the page to force Privy to refresh cookies
      // More context: https://t2world2023.slack.com/archives/C04PRPBFPDY/p1705909823392669?thread_ts=1705648272.811509&cid=C04PRPBFPDY
      // TODO: After Privy introduces fix for refresing cookies via `getAccessToken` change `router?.reload()` to `getAccessToken()`
      router?.reload();
    }
  }, [error]);

  const userArticleTimePoints = data?.getUserArticlePoaTimePoints || INITIAL_USER_ARTICLE_TIME_POINTS;

  return { userArticleTimePoints, isUserArticleTimePointsLoading };
};
